// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------

////////////////////
// spin Functions //
////////////////////

//this is a prototype module which has functions in it used buy both the standard gamecontroller and freespins. Both inherit from this module

spinFunctions = (function () {
  var _spinTask;
  var _winsTask;
  var _positions;
  var _reelsSpinning;
  var _waitingForSpinTask = false;
  var _slamStopped = false;
  var _firstLongSpinReelId = undefined;
  var _lastLongSpinReelId = undefined;
  var _longSpinReason = undefined;

  //var _bonusSymbolsLanded = 0;
  var _anticipationReels = [];
  var _longSpinLength = 35; //set how any extra symbols you want on a longSpin

  ///////////////////////////////////////////////////////////
  function onSpinEvent(spinTask) {
    spinTask.join();
    _spinTask = spinTask;
    _waitingForSpinTask = false;

    console.log(`onSpinEvent - winCapped = ${_spinTask.data.winCapped}`);

    doSpin();
  }

  ///////////////////////////////////////////////////////////
  function onPreSpin() {
    _waitingForSpinTask = true;
  }

  ///////////////////////////////////////////////////////////
  function doSpin() {
    //	return;
    // Both spin task and character must have completed before we stop the reels
    if (_waitingForSpinTask) return;

    //		gameController._receivedResponse = true;
    var spinTask = _spinTask;

    //gameController_bonusSymbolsLanded = 0;

    // this maps the positions to an array for the slot machine
    _positions = spinTask.data.resultPanel.reelList.map(function (reel, index) {
      return reel.symbols.map(function (curr) {
        return curr.value;
      });
    });

    // work out when to show anticipation anims - also need to lengthen reels spin time
    // only when 2 bonus symbols have landed and it's possible to complete a feature win
    let scatterCount = 0;
    let longSpinMultiplier = 1;

    _anticipationReels = [false, false, false, false, false];

    // OLD anticipation, this has been replaced with stuff from gigablox
    // for (let reel = 0; reel < _positions.length - 1; reel++) {
    //   for (let row = 0; row < _positions[reel].length; row++) {
    //     if (_positions[reel][row] === resourceManager.getConfiguration().symbols.Bonus.ID) {
    //       scatterCount++;
    //       break;
    //     }
    //   }

    //   if (scatterCount >= 2) {
    //     _anticipationReels[reel + 1] = true;
    //     slotMachine.stopOffsets[reel + 1] += _longSpinLength * longSpinMultiplier++;
    //   }
    // }

    // for (let line = 0; line <  gameData.slotConfig.paylines.length; line++) {
    //     var payline =  gameData.slotConfig.paylines[line].spots;
    // 	found = 0;
    // 	for (i = 0; i < 5 && i == found; i++) {
    // 		symbol = spinTask.data.resultPanel.reelList[i].symbols[payline[i]].value;
    // 		// Check for gem or wild
    // 		if (symbol === logoID || symbol === wildID) {
    // 			found++;
    // 		}
    // 	}

    //     threeOAKJackpot += (found >= 3) ? 1 : 0;
    //     fourOAKJackpot += (found >= 4) ? 1 : 0;
    // }

    // _preAppPositions = spinTask.data.resultPanel.symbolsAbove.map(function(value) {
    // 	return value.symbols.map(function(curr) {
    // 		return curr.value;
    // 	});
    // });
    // _postAppPositions = spinTask.data.resultPanel.symbolsBelow.map(function(value) {
    // 	return value.symbols.map(function(curr) {
    // 		return curr.value;
    // 	});
    // });
    // //works out if we are doing a longSpin
    // _longSpin = _positions[0].every(function(value){
    // 	return value === 13;
    // });

    // if(_is3OAKJackpot) {
    // 	//slotMachine.stopOffsets[3] += _longSpinLength;
    // 	//slotMachine.stopOffsets[4] += _longSpinLength;
    // }

    // if(_is4OAKJackpot) {
    // 	//slotMachine.stopOffsets[4] += _longSpinLength;
    // }

    const symbolsAbove = _spinTask.data.symbolsAbove;
    const symbolsBelow = _spinTask.data.symbolsBelow;
    // slotMachine.stopReels(symbolsAbove, _positions, symbolsBelow);

    // param 1 gigabloxLayout looks like '[[0],[1,2],[3,4],[5]]'
    // param 2 symbols looks like '[[0,0,2,2],[7,3,3,2],[7,0,0,5],[3,2,2,5]]'
    // param 3 above looks like '[[0],[0],[0],[0]]' - always seems to be 0, but we do have code to populate this properly
    // param 4 below looks like '[[0],[0],[0],[0]]' - always seems to be 0, but we do have code to populate this properly
    // param 5 spinCompleteCB = gameController.onSpinComplete
    // param 6 reelLandCB = gameController.onSpinLand
    // param 7 transitionCallback = function(growData, growCB)
    // param 8 longSpinCB = function(firstLongSpinReelIdx, reason, lastLongSpinReelIdx){
    // param 8 winsPerReel = looks like '[3,3,0,0,0,0]' from spinTask.data.winsOnGigabloxAnalysis
    // param 9 onDoubleWide = function (doubleWides){

    // these call backs have been emptied because we are firing a 'game:blockDistribution' event
    // we want the transitions to happen before the paw modifier occurs
    // so we cant rely on the old way of the transition happening during stopReels

    const transitionCallback = function (growData, growCB) {
      // soundManager.play('reelsGrowTo' + growData.blockSize);
      // if (growData.blockSize >= 3 && !gameController.screenShaker.isShaking()) {
      //   gameController.previousSpinHasBlock = true;
      //   gameController.screenShaker.start();
      //   gameController.leprechaunAnim.onShake();
      //   if (!soundManager.isSoundPlaying('Rumble_Loop')) {
      //     gameController.sfxRumbleId = soundManager.play('Rumble_Loop');
      //   }
      // }
      // gameController.setRumbleVolume(growData.blockSize, gameController.sfxRumbleId);
      // gameController.doGigabloxTransitionEffect(
      //   growData.startReelGlobal,
      //   growData.blockSize,
      //   function () {
      //     growCB();
      //   },
      //   0
      // );
    };

    const longSpinCB = function (firstLongSpinReelIdx, reason, lastLongSpinReelIdx) {
      _longSpinReason = reason;
      if (reason === 'BIG_BLOCK' || reason === 'BIG_BLOCK_WINS') {
        _firstLongSpinReelId = firstLongSpinReelIdx + 1;
        _lastLongSpinReelId = -1;
      } else if (reason === 'BONUS') {
        _firstLongSpinReelId = firstLongSpinReelIdx;
        _lastLongSpinReelId = -1;
      }
    };

    const onDoubleWide = function (doubleWides) {
      // soundManager.play('reelsGrowTo3');
      // for (let i = 0; i < doubleWides.length; ++i) {
      //   gameController.doGigabloxTransitionEffect(doubleWides[i], 2, function () {}, i);
      // }
    };

    const gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');
    gameController.calcLandingAnims();
    gigabloxFactory.stopReels(
      spinTask.data.gigablox.gigabloxLayout,
      spinTask.data.gigablox.symbols,
      spinTask.data.gigablox.above,
      spinTask.data.gigablox.below,
      gameController.onSpinComplete,
      gameController.onSpinLand,
      transitionCallback,
      longSpinCB,
      spinTask.data.gigablox.winsOnGigabloxAnalysis,
      onDoubleWide,
      gameController.onSpinHit,
      gameController.extraStopDistances,
      spinTask.data.champagneModifierData
    );
  }

  ///////////////////////////////////////////////////////////
  function doPayWins(winsTask) {
    // This is the wrong way to do this, it's a workaround. I have done it because the doPayWins function is being called by a messsage. It messes up the "this" reference for some reason
    var self = freespins.inFreespins ? freespins : gameController;
    _currentWinline = 0;
    _winsTask = winsTask;
    self.stateMachine.switchState('PAYWINS');
    winsTask.join();
    // Start winline animations
    self.winlineAnimationsComplete = false;
    winlineAnimationController.startWinlineAnimations(
      _winsTask.data,
      onWinlineAnimationsComplete,
      undefined,
      undefined,
      undefined,
      undefined,
      9999
    );
    messageBox.reveal();
  }

  ///////////////////////////////////////////////////////////
  function onWinlineAnimationsComplete() {
    if (freespins.inFreespins) {
      freespins.stateMachine.switchState('PAY_TO_WINNINGS');
    } else {
      gameController.stateMachine.switchState('PAY_TO_WINNINGS');
    }
  }

  function playLandSounds(reel) {
    let slamStopped = resourceManager.get('buttonContainer:buttonBar:slamStopButton').isSlammed();

    if (!slamStopped) {
      soundManager.play(`symbolLand${reel + 1}`);
    }
    if (slamStopped && reel === 4) {
      soundManager.play('symbolLand5');
    }
  }

  ///////////////////////////////////////////////////////////
  function onSpinComplete(reelID) {
    gameController.reelsSpinning = false;
    console.log('spinFunctions:onSpinComplete - gameController.reelsSpinning = false;');
  }

  ///////////////////////////////////////////////////////////
  function doSlamStop() {
    console.log('Slam stop pressed');
    _slamStopped = true;
    // we arent using the original reels
    // for (var i = 0; i < 5; ++i) {
    //   var reel = gameData.reels[i];
    //   reel.spinParams.spinSpeed = 999;
    //   reel.spinParams.decelerationDistance = 0.0;
    // }

    gameController.stopAnticipation();
    const gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');
    gigabloxFactory.doSlamStop();
    //slotMachine.slamStop();
    // for (var i = 0; i < 5 ; ++i) {
    // 	var reel = gameData.reels[i];
    // 	reel.spinParams.spinSpeed = 999;
    // 	reel.spinParams.decelerationDistance = 0.0;
    // }

    //	var stopOffsets = slotMachine.stopOffsets;
    //	var lastSlamIndex = (_longSpin) ? 3 : 4;

    //	for (var i = 0; i < gameData.reels.length; ++i) {
    //		if (i <= lastSlamIndex) stopOffsets[i] = 0;
    //	}
    //	slotMachine.slamStop(stopOffsets /*, spinParams*/ );
  }

  ///////////////////////////////////////////////////////////
  spinFunctions = {};
  Object.defineProperties(spinFunctions, {
    onSpinEvent: {
      value: onSpinEvent,
    },
    onPreSpin: { value: onPreSpin },

    spinTask: {
      get: function () {
        return _spinTask;
      },
      set: function (value) {
        _spinTask = value;
      },
    },

    winsTask: {
      get: function () {
        return _winsTask;
      },
    },
    reelsSpinning: {
      get: function () {
        return _reelsSpinning;
      },
      set: function (value) {
        _reelsSpinning = value;
      },
    },
    slamStopped: {
      get: function () {
        return _slamStopped;
      },
      set: function (value) {
        _slamStopped = value;
      },
    },
    firstLongSpinReelId: {
      get: function () {
        return _firstLongSpinReelId;
      },
      set: function (value) {
        _firstLongSpinReelId = value;
      },
    },
    longSpinReason: {
      get: function () {
        return _longSpinReason;
      },
      set: function (value) {
        _longSpinReason = value;
      },
    },
    lastLongSpinReelId: {
      get: function () {
        return _lastLongSpinReelId;
      },
      set: function (value) {
        _lastLongSpinReelId = value;
      },
    },
    doSlamStop: {
      value: doSlamStop,
    },
    onSpinComplete: {
      value: onSpinComplete,
    },
    doPayWins: {
      value: doPayWins,
    },
    longSpinActive: {
      get: function () {
        return _longSpinActive;
      },
    },
    playLandSounds: {
      value: playLandSounds,
    },
  });
  return spinFunctions;
})();
